import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import Store from '@ember-data/store';
import PledgeModel from 'donor-elf-web/models/pledge';
import ContactsCache from 'donor-elf-web/services/contacts-cache';
import FundsService from 'donor-elf-web/services/funds-service';

export default class TotalGivenExpectingRoute extends Route {
  @service declare contactsCache: ContactsCache;
  @service declare fundsService: FundsService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'Given and Expecting';
  }

  async model() {
    let givenExpectingReport = await this.store.findRecord(
      'total-given-expecting-report',
      this.fundsService.selectedFund!.id,
    );

    let pledgeSections = givenExpectingReport.data?.pledges || {};
    let expectedPledgeIds: string[] =
      pledgeSections.expected?.map(e => e.pledge_id) || [];
    let overduePledgeIds: string[] =
      pledgeSections.overdue?.map(o => o.pledge_id) || [];
    let pledgeIds = [...expectedPledgeIds, ...overduePledgeIds];

    let pledges: PledgeModel[] = [];
    if (pledgeIds.length > 0) {
      pledges = (
        await this.store.query('pledge', { filter: { id: pledgeIds } })
      ).slice();
    }
    let pledgesById: { [pledgeId: string]: PledgeModel } = {};
    let pledgesByContactId: { [contactId: string]: PledgeModel[] } = {};
    pledges.forEach((pledge) => {
      pledgesById[pledge.id] = pledge;
      if (pledgesByContactId[pledge.contactId!] == null) {
        pledgesByContactId[pledge.contactId!] = [];
      }
      pledgesByContactId[pledge.contactId!].push(pledge);
    });

    let expectedItemsByContactId: { [contactId: string]: any[] } = {};
    if (pledgeSections.expected) {
      pledgeSections.expected.forEach((item: any) => {
        let pledge = pledgesById[item.pledge_id];
        item.pledge = pledge;
        if (expectedItemsByContactId[pledge.contactId!] == null) {
          expectedItemsByContactId[pledge.contactId!] = [];
        }
        expectedItemsByContactId[pledge.contactId!].push(item);
      });
    }
    let contactExpectingItems: any[] = [];
    Object.keys(expectedItemsByContactId).forEach((contactId) => {
      let items = expectedItemsByContactId[contactId] || [];

      contactExpectingItems.push({
        contact: this.contactsCache.contactsById[contactId],
        contactId,
        expectedItems: sortByProperties(items, ['expected_amount:desc']),
        totalExpecting: items
          .map((x) => x.expected_amount)
          .reduce((x, y) => x + y, 0),
      });
    });

    let overdueItemsByContactId: { [contactId: string]: any[] } = {};
    pledgeSections.overdue?.forEach((item: any) => {
      let pledge = pledgesById[item.pledge_id];
      item.pledge = pledge;
      if (overdueItemsByContactId[pledge.contactId!] == null) {
        overdueItemsByContactId[pledge.contactId!] = [];
      }
      overdueItemsByContactId[pledge.contactId!].push(item);
    });
    let contactOverdueItems: any[] = [];
    Object.keys(overdueItemsByContactId).forEach((contactId) => {
      let items = overdueItemsByContactId[contactId] || [];
      contactOverdueItems.push({
        contact: this.contactsCache.contactsById[contactId],
        contactId,
        items,
        totalExpecting: items
          .map((x) => x.expected_amount)
          .reduce((x, y) => x + y, 0),
      });
    });

    return {
      givenExpectingReport,
      contactExpectingItems,
      contactOverdueItems,
    };
  }
}
